module.exports = __webpack_public_path__ + "img/cillectove15.896eb931.png";